<template>
    <DynamicTag
        v-bind="$attrs"
        :tag="tag"
        :style="elStyles"
        :lines="lines"
        class="patsnap-biz-text_truncate"
        v-on="$listeners"
    >
        <slot />
    </DynamicTag>
</template>

<script>
const DynamicTag = {
    functional: true,
    render(c, { props, data, children }) {
        return c(props.tag, data, children);
    },
};

export default {
    name: 'PtTextTruncate',
    components: {
        DynamicTag,
    },
    props: {
        tag: {
            type: String,
            default: 'div',
        },
        resizable: {
            type: Boolean,
            default: true,
        },
        lines: {
            type: Number,
            default: 2,
        },
    },
    data() {
        return {
            elStyles: {},
        };
    },
    watch: {
        lines: {
            handler() {
                this.handleHeight();
                this.$nextTick(() => {
                    this.handleText();
                });
            },
            immediate: true,
        },
    },
    mounted() {
        this.handleHeight();
        this.$nextTick(() => {
            this.handleText();
            if (!this.resizable) return;
            this.resizeObserver = new ResizeObserver(() => {
                clearTimeout(this.it);
                this.it = setTimeout(() => {
                    this.handleText();
                }, 200);
            });
            this.resizeObserver.observe(this.$el);
        });
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    },
    methods: {
        getInnerHtml() {
            if (!this.originalInnerHTML) {
                this.originalInnerHTML = this.$el.innerHTML;
            }
            return this.originalInnerHTML;
        },
        handleHeight() {
            if (!this.$el) return;
            const lineHeight = this.getLineHeight();
            const maxHeight = lineHeight * this.lines;
            const styles = {
                minHeight: `${lineHeight}px`,
                textOverflow: 'clip',
                wordWrap: 'break-word',
                height: `${maxHeight}px`,
            };
            this.elStyles = styles;
        },
        getLineHeight() {
            return parseInt(window.getComputedStyle(this.$el).lineHeight, 10);
        },
        handleText() {
            const text = this.getInnerHtml();
            const el = this.$el;
            const h = el.offsetHeight;
            for (let i = 0; i <= text.length; i += 1) {
                el.innerHTML = text.substr(0, i);
                if (h < el.scrollHeight) {
                    el.style.overflow = 'hidden';
                    el.innerHTML = `${text.substr(0, i - 3)}...`;
                    break;
                }
            }

            const span = document.createElement('span');
            span.innerText = el.innerText;
            span.style.visibility = 'hidden';
            el.appendChild(span);
            const { height, ...styles } = this.elStyles;
            /* 计算出的文本行数 */
            const value = Math.ceil(span.offsetHeight / 16);
            el.removeChild(span);
            /* 计算出的文本行数，如果指定行数 lines，则容器需要收缩 */
            if (value < this.lines) {
                this.elStyles = { ...styles, height: `${value * this.getLineHeight()}px` };
            }
        },
    },
};
</script>
